import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=d6754660&scoped=true&lang=pug&"
import script from "./ActionButtons.vue?vue&type=script&lang=ts&"
export * from "./ActionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=d6754660&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6754660",
  null
  
)

export default component.exports